export const styles = {
  container: {
    display: 'flex',
    height: 'calc(100vh - 64px)',
    backgroundColor: '#f5f5f5',
    margin: '20px',
    borderRadius: '8px',
    boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
    overflow: 'hidden',
  },
  sidebar: {
    width: '320px',
    backgroundColor: '#fff',
    borderRight: '1px solid #e8e8e8',
    padding: '24px',
    overflowY: 'auto',
    borderTopLeftRadius: '8px',
    borderBottomLeftRadius: '8px',
  },
  topicsList: {
    listStyle: 'none',
    padding: 0,
    margin: '16px 0 0 0',
  },
  topicItem: {
    display: 'flex',
    alignItems: 'center',
    padding: '14px 18px',
    cursor: 'pointer',
    borderRadius: '8px',
    marginBottom: '6px',
    transition: 'all 0.2s ease',
    gap: '12px',
    fontSize: '14px',
    fontWeight: '500',
    border: '1px solid transparent',
  },
  topicItemDefault: {
    backgroundColor: 'transparent',
    color: '#666',
  },
  topicItemSelected: {
    backgroundColor: "#1890ff",
    color: "#fff",
    border: "1px solid #1890ff",
    boxShadow: "0 2px 4px rgba(24,144,255,0.2)",
    position: "relative",
    zIndex: 1,
  },
  topicItemHover: {
    backgroundColor: '#f8f9fa',
    border: '1px solid #e8e8e8',
  },
  content: {
    flex: 1,
    padding: '24px',
    overflowY: 'auto',
    backgroundColor: '#fafafa',
    borderTopRightRadius: '8px',
    borderBottomRightRadius: '8px',
  },
  renderedContent: {
    maxWidth: '100%',
    overflow: 'hidden',
  },
};

export const contentStyles = `
  .ant-card-body {
    padding-top: 0 !important;
  }
  .tag-help-content {
    margin-top: 0 !important;
    padding-top: 0 !important;
  }
  .tag-help-content > *:first-child {
    margin-top: 0 !important;
    padding-top: 0 !important;
  }
  .tag-help-content img {
    max-width: 100% !important;
    height: auto !important;
    display: block;
    margin: 10px 0;
  }
  .tag-help-content table {
    max-width: 100% !important;
    overflow-x: auto;
    display: block;
    white-space: nowrap;
  }
  .tag-help-content h1:first-child {
    margin-top: 0 !important;
  }
  .tag-help-content h2:first-child {
    margin-top: 0 !important;
  }
  .tag-help-content h3:first-child {
    margin-top: 0 !important;
  }
  .tag-help-content h1 {
    font-size: 28px !important;
    font-weight: 700 !important;
    margin: 24px 0 16px 0 !important;
    color: #262626 !important;
    line-height: 1.3 !important;
  }
  .tag-help-content h2 {
    font-size: 22px !important;
    font-weight: 600 !important;
    margin: 20px 0 12px 0 !important;
    color: #262626 !important;
    line-height: 1.4 !important;
  }
  .tag-help-content h3 {
    font-size: 18px !important;
    font-weight: 600 !important;
    margin: 16px 0 8px 0 !important;
    color: #262626 !important;
    line-height: 1.4 !important;
    display: block !important;
    border-bottom: 1px solid #e8e8e8 !important;
    padding-bottom: 4px !important;
  }
  .tag-help-content strong {
    font-weight: 600 !important;
    color: #262626 !important;
  }
  .tag-help-content em {
    font-style: italic !important;
  }
  .tag-help-content ul {
    margin: 12px 0 !important;
    padding-left: 20px !important;
  }
  .tag-help-content li {
    margin: 6px 0 !important;
    line-height: 1.6 !important;
  }
  .tag-help-content p {
    margin: 12px 0 !important;
    line-height: 1.6 !important;
    color: #595959 !important;
  }
`;
